(function () {
  'use strict';

  var ELEVATION_IMAGE = 'https://cdn.shopify.com/s/files/1/0646/3268/4615/files/WC_2021-11-11_mono_8_of_245.jpg?v=1782478012';

  function replaceVisibleText(root, pattern, replacement) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(node.parentElement.tagName)) continue;
      if (pattern.test(node.nodeValue || '')) node.nodeValue = node.nodeValue.replace(pattern, replacement);
      pattern.lastIndex = 0;
    }
  }

  function fixVineyardElevationImage(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('img[alt="Veraison - grapes changing colour"], img[data-wc-elevation-image]').forEach(function (image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = ELEVATION_IMAGE;
      image.alt = 'Two people walking through the Weathercraft vineyard';
      image.dataset.wcElevationImage = 'true';
    });
  }

  function run(root) {
    var scope = root || document;
    fixVineyardElevationImage(scope);
    replaceVisibleText(scope === document ? document.getElementById('MainContent') : scope, /gravelly inclines and spare/gi, 'gravelly incline and sparse');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); }, { once: true });
  else run(document);
  document.addEventListener('shopify:section:load', function (event) { run(event.target || document); });
})();

(function () {
  'use strict';

  var STORAGE_KEY = 'wc_pending_storefront_form';
  var RETURN_PARAM = 'wc_form';
  var MAX_PENDING_AGE = 30 * 60 * 1000;
  var restoreTimer = null;
  var FORM_CONFIGS = [
    { selector: '.wc-site-footer__newsletter', type: 'footer-newsletter', message: 'Thanks - you are now subscribed!' },
    { selector: '.wc-contact-page-form__form', type: 'contact-page', message: 'Thank you - your message has been sent. We will be in touch shortly.' },
    { selector: '.wc-contact-wholesale__form', type: 'wholesale', message: 'Thank you. Your trade enquiry has been received.' },
    { selector: '.wc-contact__form', type: 'contact-basic', message: 'Thank you. Your message has been sent.' }
  ];

  function configForForm(form) {
    for (var i = 0; i < FORM_CONFIGS.length; i += 1) if (form.matches(FORM_CONFIGS[i].selector)) return FORM_CONFIGS[i];
    return null;
  }

  function configForType(type) {
    for (var i = 0; i < FORM_CONFIGS.length; i += 1) if (FORM_CONFIGS[i].type === type) return FORM_CONFIGS[i];
    return null;
  }

  function safelyStorePending(config, form) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ type: config.type, formId: form.id || '', path: window.location.pathname, submittedAt: Date.now() }));
    } catch (error) {}
  }

  function readPending() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      var pending = raw ? JSON.parse(raw) : null;
      if (!pending) return null;
      if (Date.now() - Number(pending.submittedAt || 0) > MAX_PENDING_AGE) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return pending;
    } catch (error) { return null; }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  function addReturnMarker(config, form) {
    var returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      returnInput.value = window.location.pathname + window.location.search + window.location.hash;
      form.appendChild(returnInput);
    }
    try {
      var target = new URL(returnInput.value || window.location.href, window.location.origin);
      target.searchParams.set(RETURN_PARAM, config.type);
      returnInput.value = target.pathname + target.search + target.hash;
    } catch (error) {}
  }

  function pendingFromReturnMarker() {
    try {
      var type = new URL(window.location.href).searchParams.get(RETURN_PARAM);
      if (!type || !configForType(type)) return null;
      return { type: type, formId: '', path: window.location.pathname, submittedAt: Date.now() };
    } catch (error) { return null; }
  }

  function removeReturnMarker() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(RETURN_PARAM)) return;
      url.searchParams.delete(RETURN_PARAM);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  function exactPendingForm(pending, config) {
    if (pending.formId) {
      var byId = document.getElementById(pending.formId);
      if (byId && byId.matches(config.selector)) return byId;
    }
    return document.querySelector(config.selector);
  }

  function hasVisibleError(form) {
    var errors = form.querySelectorAll('.wc-form-status--error, .errors');
    for (var i = 0; i < errors.length; i += 1) {
      var error = errors[i];
      var style = window.getComputedStyle(error);
      var visible = !error.hidden && style.display !== 'none' && style.visibility !== 'hidden';
      if (visible && error.textContent.trim()) return true;
    }
    return false;
  }

  function hideOtherSuccessMessages(activeForm) {
    document.querySelectorAll('.wc-form-status--success').forEach(function (status) {
      if (!activeForm.contains(status)) status.hidden = true;
    });
  }

  function ensureSuccessMessage(form, message) {
    var status = form.querySelector('.wc-form-status--success');
    if (!status) {
      status = document.createElement('div');
      status.className = 'wc-form-status wc-form-status--success';
      form.insertBefore(status, form.firstChild);
    }
    status.hidden = false;
    status.removeAttribute('aria-hidden');
    status.setAttribute('role', 'status');
    status.setAttribute('tabindex', '-1');
    status.setAttribute('data-wc-restored-success', 'true');
    status.textContent = message;
    return status;
  }

  function scrollToForm(form, status) {
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        var header = document.getElementById('header-group');
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        var top = form.getBoundingClientRect().top + window.scrollY - headerHeight - 18;
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        try { status.focus({ preventScroll: true }); } catch (error) { status.focus(); }
      }, 80);
    });
  }

  function restoreSubmittedFormSuccess() {
    var storedPending = readPending();
    var markerPending = pendingFromReturnMarker();
    var pending = storedPending || markerPending;
    if (!pending) return;
    var config = configForType(pending.type);
    if (!config) {
      clearPending();
      removeReturnMarker();
      return;
    }
    var form = exactPendingForm(pending, config);
    if (!form) return;
    if (hasVisibleError(form)) {
      clearPending();
      removeReturnMarker();
      return;
    }
    hideOtherSuccessMessages(form);
    var status = ensureSuccessMessage(form, config.message);
    if (config.type === 'footer-newsletter') {
      document.dispatchEvent(new CustomEvent('wc:newsletter-confirmed', {
        detail: { form_id: form.id || 'footer-newsletter', submitted_at: Number(pending.submittedAt || Date.now()) }
      }));
    }
    clearPending();
    removeReturnMarker();
    scrollToForm(form, status);
  }

  function scheduleRestore(delay) {
    if (restoreTimer) window.clearTimeout(restoreTimer);
    restoreTimer = window.setTimeout(restoreSubmittedFormSuccess, delay || 0);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var config = configForForm(form);
    if (!config) return;
    addReturnMarker(config, form);
    safelyStorePending(config, form);
  }, true);

  window.addEventListener('pageshow', function () { scheduleRestore(40); });
  document.addEventListener('shopify:section:load', function () { scheduleRestore(80); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleRestore(40);
      window.setTimeout(restoreSubmittedFormSuccess, 350);
    }, { once: true });
  } else {
    scheduleRestore(40);
    window.setTimeout(restoreSubmittedFormSuccess, 350);
  }
})();

(function () {
  'use strict';

  var VERSION = '2026-08-05';
  var CURRENCY = 'AUD';
  var observed = Object.create(null);
  var emitted = Object.create(null);

  function safeGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function safeSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) {}
  }

  function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function money(cents) { return Number(cents || 0) / 100; }

  function emitOnce(key, eventName, parameters) {
    var storageKey = 'wc_event_once:' + key;
    if (emitted[key] || safeGet(storageKey) === 'true') return false;
    var helper = window.WeathercraftPhase2Analytics;
    if (!helper || typeof helper.emit !== 'function') return false;
    helper.emit(eventName, Object.assign({}, parameters || {}, {
      measurement_source: 'weathercraft_analytics_completion',
      measurement_version: VERSION
    }));
    emitted[key] = true;
    safeSet(storageKey, 'true');
    return true;
  }

  document.addEventListener('wc:analytics', function (event) {
    if (event.detail && event.detail.event) observed[event.detail.event] = true;
  });

  function winesItem(card, index) {
    var button = card.querySelector('.wc-product-card__atc');
    var link = card.querySelector('a[href*="/products/"]');
    var title = button && button.dataset.productTitle || card.querySelector('.wc-product-card__title') && card.querySelector('.wc-product-card__title').textContent;
    var handle = link && link.getAttribute('href') && link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
    return {
      item_id: String(button && button.dataset.variantId || handle || index + 1),
      item_name: clean(title),
      item_brand: 'Weathercraft',
      price: money(card.dataset.price),
      index: index,
      item_list_id: 'weathercraft_wines',
      item_list_name: 'Weathercraft Wines'
    };
  }

  function fallbackItemList() {
    if (observed.view_item_list) return;
    var catalogue = document.querySelector('[data-wc-catalogue]');
    if (!catalogue) return;
    var cards = Array.prototype.slice.call(catalogue.querySelectorAll('.wc-product-card'));
    if (!cards.length) return;
    emitOnce('view_item_list:' + (catalogue.dataset.wcCatalogue || 'weathercraft_wines'), 'view_item_list', {
      currency: CURRENCY,
      item_list_id: 'weathercraft_wines',
      item_list_name: 'Weathercraft Wines',
      items: cards.map(winesItem)
    });
  }

  function fallbackSelectItem(event) {
    var link = event.target.closest('[data-wc-catalogue] .wc-product-card a[href*="/products/"]');
    if (!link) return;
    window.queueMicrotask(function () {
      if (observed.select_item) return;
      var card = link.closest('.wc-product-card');
      var catalogue = link.closest('[data-wc-catalogue]');
      if (!card || !catalogue) return;
      var cards = Array.prototype.slice.call(catalogue.querySelectorAll('.wc-product-card'));
      var index = Math.max(0, cards.indexOf(card));
      var item = winesItem(card, index);
      emitOnce('select_item:' + item.item_id + ':' + Date.now(), 'select_item', {
        currency: CURRENCY,
        item_list_id: 'weathercraft_wines',
        item_list_name: 'Weathercraft Wines',
        items: [item]
      });
    });
  }

  function cartItem(item, index) {
    return {
      item_id: String(item.variant_id || item.id || item.key || ''),
      item_name: item.product_title || item.title || 'Wine',
      item_brand: item.vendor || 'Weathercraft',
      item_variant: item.variant_title || undefined,
      price: money(item.final_price || item.price || item.original_price || 0),
      quantity: Number(item.quantity || 1),
      index: index
    };
  }

  function fallbackViewCart() {
    if (window.location.pathname !== '/cart' || observed.view_cart) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
      .then(function (cart) {
        if (observed.view_cart || !cart.items || !cart.items.length) return;
        var key = 'view_cart:' + String(cart.token || '') + ':' + String(cart.item_count || 0) + ':' + String(cart.total_price || 0);
        emitOnce(key, 'view_cart', {
          currency: cart.currency || CURRENCY,
          value: money(cart.total_price),
          items: cart.items.map(cartItem),
          cart_view_source: 'cart_page_fallback'
        });
      })
      .catch(function () {});
  }

  function measureSearch() {
    if (window.location.pathname !== '/search') return;
    var term = clean(new URLSearchParams(window.location.search).get('q'));
    if (!term) {
      var input = document.querySelector('input[type="search"][name="q"], input[name="q"]');
      term = clean(input && input.value);
    }
    if (!term) return;
    emitOnce('search:' + term.toLowerCase(), 'search', { search_term: term });
  }

  function emitNewsletter(detail) {
    var stamp = Number(detail && detail.submitted_at || Date.now());
    var formId = clean(detail && detail.form_id || 'footer-newsletter');
    emitOnce('join_newsletter:' + formId + ':' + stamp, 'join_newsletter', {
      method: 'footer_form',
      form_location: 'footer',
      form_id: formId
    });
  }

  document.addEventListener('wc:newsletter-confirmed', function (event) { emitNewsletter(event.detail || {}); });
  document.addEventListener('click', fallbackSelectItem, true);

  function initialise() {
    measureSearch();
    window.setTimeout(fallbackItemList, 700);
    window.setTimeout(fallbackViewCart, 1100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
